import participationUrl from "../participationUrl";

const updateLastSectionCompleted = async (studyId, body) => {
    navigator.sendBeacon(participationUrl() + "/participation/studies/" + studyId + "/update-last-section-completed", JSON.stringify(body))
}

export default updateLastSectionCompleted